<template>
  <v-row no-gutters wrap>
    <v-col cols="12">
      <!-- <v-card> -->
        <v-navigation-drawer app height='100%' :mini-variant.sync='mini' stateless hide-overlay clipped v-model='isSankey' width='400'>
          <v-toolbar color='grey darken-3' dark>
            <v-btn text icon @click.stop="mini=!mini,items.forEach((el,i)=>{if(mini==true){items[i].active=0}else{items[i].active=1}})">
              <v-icon>menu</v-icon>
            </v-btn>
            <v-toolbar-title>Simulation Input</v-toolbar-title>
            <v-spacer/>
            <v-btn text icon @click.stop="mini=!mini,items.forEach((el,i)=>items[i].active=0)">
              <v-icon>chevron_left</v-icon>
            </v-btn>
          </v-toolbar>
          <v-list expand class="scrollable scrollbar scrollVisible">
            <v-list-group
              v-for="item in items"
              :key="item.title"
              v-model="item.active"
              :prepend-icon="item.action"
              append-icon="expand_more"
              no-action
            >
              <template v-slot:activator>
                  <v-list-item-title class='title'>{{ item.title }}</v-list-item-title>
              </template>

              <v-list-item
                v-for="subItem in filterItems(item.items)"
                :key="subItem.title"
              >
                <v-tooltip max-width="400" offset-overflow bottom nudge-top="20">
                  <template v-slot:activator="{on: tooltip}">
                    <div  v-if="subItem.type=='select'" v-on="tooltip" style="width:100%">
                      <v-select class="mr-1" append-icon='expand_more' width='100%' v-model=subItem.value :items=subItem.items @input="inputChange(subItem)" :label=subItem.title></v-select>
                    </div>
                    <v-text-field v-else-if="subItem.type=='input'" class='mr-1' v-model=subItem.value v-on="tooltip" @change="inputChange(subItem)" type="number" :label=subItem.title :max=subItem.max></v-text-field>
                    <v-card v-else-if="subItem.type=='slider'" v-on="tooltip" flat color='transparent' width='100%'>
                      <v-subheader class="align-start px-0 mx-0">{{subItem.title}}</v-subheader>
                      <v-slider class="mr-1 mt-1" v-model=subItem.value thumb-label="always" thumb-size="28" :min=0 :max=subItem.max :step=subItem.stepSize @input="inputChange(subItem)"></v-slider>
                    </v-card>
                    <v-card v-else-if="subItem.type=='combobox'" v-on="tooltip" class="mx-0 px-0" flat color='transparent' width='100%'>
                      <v-row no-gutters class='mr-1 ml-1'>
                        <v-flex xs9>
                          <v-combobox v-model=subItem.value append-icon="expand_more" :label=subItem.title :items=subItem.items @change="(a)=>{subItem.efficiency = a.value; inputChange(subItem)}"></v-combobox>
                        </v-flex>
                        <v-flex xs3>
                          <v-text-field type='number' min="0.01" v-model=subItem.efficiency :label=subItem.units  @input="inputChange(subItem)"></v-text-field>
                        </v-flex>
                      </v-row>
                    </v-card>
                  </template>
                  <!-- <v-row no-gutters full-width> -->
                    <span v-if="subItem.hasOwnProperty('tooltip')">{{subItem.tooltip}}<br/></span>
                    <!-- <v-col v-if="subItem.hasOwnProperty('avatar')" cols="auto"> -->
                    <v-img v-if="subItem.hasOwnProperty('avatar')" contain :src='subItem.avatar()'></v-img>
                    <!-- </v-col> -->
                    <!-- <v-col> -->
                    <!-- </v-col> -->
                  <!-- </v-row> -->
                </v-tooltip>
              </v-list-item>
              <v-divider/>
            </v-list-group>
          </v-list>
        </v-navigation-drawer>
      <!-- </v-card> -->
    </v-col>
  </v-row>
</template>

<script>
export default {
  data: () => ({
    drawer: true,
    mini: false,
    // baseYear: 2019,
    items: [
          {
            active: 1,
            action: 'map',
            title: 'Environment',
            items: [
              { title: 'Location',
                type: 'select',
                items: [
                  {text: 'Asheville, NC', disabled: true},
                  {text: 'Atlanta, GA', disabled: false},
                  {text: 'Boston, MA', disabled: true},
                  {text: 'Chicago, IL', disabled: false},
                  {text: 'Dallas, TX', disabled: true},
                  {text: 'Los Angeles, CA', disabled: true},
                  {text: 'Miami, FL', disabled: true},
                  {text: 'New Orleans, LA', disabled: true},
                  {text: 'Orlando, FL', disabled: true},
                  {text: 'Pheonix, AZ', disabled: true},
                  {text: 'Seattle, WA', disabled: true},
                  {text: 'Beijing, CN', disabled: true},
                  {text: 'Lagos, NG', disabled: true},
                  {text: 'Paris, FR', disabled: true},
                ],
                value: {text: 'Atlanta, GA', disabled: false},
                tooltip: 'Used for determining weather data and solar position',
                disabled: false,
              },
              {
                title: 'Test Year',
                type: 'select',
                min: '1900',
                max: '2050',
                items: [
                  {text: '1950', disabled: true},
                  {text: '1960', disabled: true},
                  {text: '1970', disabled: true},
                  {text: '1980', disabled: true},
                  {text: '1990', disabled: true},
                  {text: '2000', disabled: true},
                  {text: '2010', disabled: true},
                  {text: '2017', disabled: false},
                  {text: '2018', disabled: false},
                  {text: '2019', disabled: true},
                  {text: '2050', disabled: false}
                ],
                value: '2017',
                tooltip: 'Used for determining weather data'
              },
              { title: 'Climate Change (Temperature Change)',
                type: 'select',
                min: '-5',
                max: '5',
                //items: ['+5 \xB0F','+4 \xB0F','+3 \xB0F','+2 \xB0F','+1 \xB0F','\xB10 \xB0F','-1 \xB0F','-2 \xB0F','-3 \xB0F','-4 \xB0F','-5 \xB0F'],
                items: [
                  {text: 'No Impact', disabled: true},
                  {text:'Low Impact: +1 \xB0F', disabled: true},
                  {text: 'Medium Impact: +3 \xB0F', disabled: true},
                  {text: 'High Impact: +5 \xB0F', disabled: false}
                ],
                value: 'High Impact: +5 \xB0F',
                tooltip: 'Average temperature increase from Y2018'
              },
              { title: 'Climate Change (Precipitation Pattern)',
                type: 'select',
                min: '-5',
                max: '5',
                items: [
                  {text: 'No Impact', disabled: false},
                  {text: 'More Drought', disabled: true},
                  {text: 'Less drought', disabled: true}
                ],
                value: 'No Impact',
                tooltip: 'Difference in drought frequency compared to Y2018'
              },
            ]
          },
          {
            active: 1,
            action: 'location_city',
            title: 'Building Characteristics',
            items: [
              { title: 'Gross Area (sqft)',
                type: 'input',
                value: 25000,
                tooltip: 'Gross square footage (ft^2)',
              },
              { title: 'Number of Floors',
                type: 'input',
                value: 2,
                tooltip: 'The number of floors the gross area is divided between'
              },
              { title: 'Building Type',
                type: 'select',
                items: [
                  {text: 'Educational', disabled: false},
                  {text: 'Residential', disabled: false},
                  {text: 'Office', disabled: true},
                  {text: 'Healthcare', disabled: true}
                ],
                value: 'Educational',
                tooltip: 'Primary usage type of the building'
              },
              { title: 'Usage',
                type: 'select',
                items: ['High','Standard','Low'],
                value: 'Standard',
                tooltip: 'How occupancy compares to standard buildings of this type'
              },
              { title: 'Construction Quality',
                type: 'select',
                items: ['Code Compliant','Green Building Certified','Net Zero Energy','Regenerative Building'],
                value: 'Regenerative Building',
                tooltip: 'Certification Level'
              },
              //{ title: 'Daily People Hours',
              //  type: 'input',
              //  value: 2000
              //}
            ]
          },
          {
            active: 1,
            action: 'battery_charging_full',
            title: 'Energy Management',
            items: [
              { title: 'Solar Array Power (kW-DC)',
                type: 'slider',
                value: 256,
                tooltip: 'Assumes the most efficient PV panel with an area equal to the rain catchment area',
                max: 307, //place max at 120% of roof area for canopy
                stepSize: 1,
              },
              // { title: 'Energy Storage (kwh)',
              //   type: 'input',
              //   value: 0,
              //   tooltip: 'Maximum energy storage capacity of building'
              // },
              { title: 'Lightbulb Type',
                type: 'combobox',
                items: [{text: 'LED', value: 9.5},{text: 'CFL', value: 13},{text: 'Incandescent',value: 60}],
                value: {text: 'LED', value: 9.5},
                efficiency: 9.5,
                units: 'Watts',
                color: 'transparent',
                tooltip: 'Type of the majority of lightbulbs'
              },
              { title: 'HVAC Type',
                type: 'select',
                items: [{text: 'VAV + Radiant Floors', value: 0.04},{text: 'VAV only',value: 0.8}],
                value: {text: 'VAV + Radiant Floors', value: 0.04},
                efficiency: 0.04,
                units: 'Watts',
                color: 'transparent',
                tooltip: 'HVAC technology type'
              },
              { title: 'Windows',
                type: 'combobox',
                items: [{text:'Single Pane',value: 100},{text: 'Double Pane',value: 80},{text: 'Triple Pane',value: 60}],
                value: {text:'Triple Pane',value: 60},
                efficiency: 60,
                units: '% Energy Loss',
                color: 'transparent',
                tooltip: 'Type of windows'
              },
            ]
          },
          {
            active: 1,
            action: 'waves',
            title: 'Water Management',
            items: [
              { title: 'Rain Catchment Area (thousands of sqft)',
                type: 'slider',
                value: 12.5,
                // tooltip: 'Rooftop area capable of catching rain',
                tooltip: 'KBISD collects all of its drinking water from the rain falling on its 21,000 sqft roof. For perspective, each inch of rainfall equates to roughly 13,000 gallons, or about 1 average sized American swimming pool!',
                max: 15,
                stepSize: 0.1
              },
              { title: 'Cistern Volume (thousands of gallons)',
                type: 'slider',
                value: 20,
                // tooltip: 'Maximum capacity of building cistern',
                tooltip: 'KBISD collects rainwater from the roof into a 50,000 gallon tank called a cistern. That’s about 4 times more water than the average American swimming pool!',
                max: 30,
                stepSize: 0.1
              },
              { title: 'Toilet Type',
                type: 'combobox',
                items: [{text: 'Foam Flush Composting', value: 0.04},{text: '3x Foam Flush Composting', value: 0.12},{text: 'Ultra High Efficiency',value: 0.8},{text: 'High Efficiency',value: 1.28},{text: 'Construction Grade', value: 1.6}],
                value: {text: 'Foam Flush Composting', value: 0.04},
                efficiency: 0.04,
                units: 'gal',
                color: 'amber lighten-5',
                avatar: ()=>{return require('@/assets/compostingToiletDiagramText.png')},
                // tooltip: "Each person in the building will likely use a toilet 3 times a day! KBISD's Foam Flush Composting Toilets use a few tablespoons of water to create a slippery foam in the toilet bowl. These composting toilets, turn your number two into food for plants on Georgia Tech's campus!"
              },
              { title: 'Faucet Type',
                type: 'combobox',
                items: [{text:'Ultra High Efficiency',value: 0.09},{text: 'High Efficiency',value: 0.13}],
                value: {text:'Ultra High Efficiency',value: 0.09},
                efficiency: 0.09,
                units: 'gal',
                color: 'transparent',
                tooltip: 'A full time user will likely use a lavatory faucet 3 times a day!'
              },
            ]
          },
        ],
  }),
  methods: {
    display(msg){
      console.log(msg)
    },
    filterItems(items){
      // console.log(this.baseYear)
      if(this.baseYear <= 2020){
        // console.log('future year')
        return items.filter((item)=>{
          return item.title != 'Climate Change (Temperature Change)' && item.title != 'Climate Change (Precipitation Pattern)'
        })
      }else{
        return items
      }
    },
    inputChange(subItem){
      // console.log(subItem)
      if(subItem.title == 'Toilet Type'){
        this.$store.commit('changeToiletType',subItem);
      }else if(subItem.title == 'Faucet Type'){
        this.$store.commit('changeFaucetType',subItem);
      }else if(subItem.title == 'Cistern Volume (thousands of gallons)'){
        this.$store.commit('changeCisternSize',subItem);
      }else if(subItem.title == 'Gross Area (sqft)'){
        this.items[2].items[0].value = Math.round(this.getSolarPower);
        this.items[2].items[0].max = Math.round(1.2*this.getSolarPower);
        this.inputChange(this.items[2].items[0]);
        this.items[3].items[0].value = Math.round(this.getRainCatchmentArea);
        this.items[3].items[0].max = Math.round(1.2*this.getRainCatchmentArea);
        this.items[3].items[1].value = Math.round(this.getCisternSize);
        this.items[3].items[1].max = Math.round(1.5*this.getCisternSize);
        this.inputChange(this.items[3].items[1]);
        this.$store.commit('changeGrossArea',subItem.value)
      }else if(subItem.title == 'Number of Floors'){
        this.items[2].items[0].value = Math.round(this.getSolarPower);
        this.items[2].items[0].max = Math.round(1.2*this.getSolarPower);
        this.inputChange(this.items[2].items[0]);
        this.items[3].items[0].value = Math.round(this.getRainCatchmentArea);
        this.items[3].items[0].max = Math.round(1.2*this.getRainCatchmentArea);
        this.items[3].items[1].value = Math.round(this.getCisternSize);
        this.items[3].items[1].max = Math.round(1.5*this.getCisternSize);
        this.inputChange(this.items[3].items[1]);
      }else if(subItem.title == 'Solar Array Power (kW-DC)'){
        this.$store.commit('changeSolarArraySize',subItem);
      }else if(subItem.title == 'Lightbulb Type'){
      this.$store.commit('changeLightbulbType',subItem);
      }else if(subItem.title == 'HVAC Type'){
        this.$store.commit('changeHVACType',subItem);
      }else if(subItem.title == 'Windows'){
        this.$store.commit('changeWindowType',subItem);
      }else if(subItem.title == 'Location'){
        this.$store.commit('changeLocation',subItem.value)
      }else if(subItem.title == 'Test Year'){
        this.$store.commit('changeBaseYear',subItem.value)
      }else if(subItem.title == 'Usage'){
        this.$store.commit('changeUsage',subItem);
      }else if(subItem.title == 'Building Type'){
        // console.log(subItem.value)
        if(subItem.value == 'Residential'){
          this.items[1].items[0].value = 2500;
        }else if(subItem.value == 'Educational'){
          this.items[1].items[0].value = 25000;
        }
        this.$store.commit('changeBuildingType',[subItem.value,this.getSolarPower])
        this.inputChange(this.items[1].items[0]);
      }
    },
  },
  // watch: {
  //   items: function(newItem,oldItem){
  //     this.inputChange(newItem)
  //   },
  // },
  computed: {
    baseYear(){
      return this.$store.state.weather.baseYear;
    },
    solarArrayKfactor(){
      return this.$store.state.energy.kFactors.solarArraySize;
    },
    isSankey() {
      return this.$route.path === '/rbs'
    },
    getSolarPower(){
      // return total solar power on roof in kW
      // assume the gross area is evenly divided by floors
      //assume individual panel is 360W and 17.6sqft
      // console.log(this.solarArrayKfactor)
      // console.log('Solar Power in kW' + this.items[1].items[0].value/(this.items[1].items[1].value)/17.6*360/1000)
      return Math.round(this.items[1].items[0].value/(this.items[1].items[1].value)/17.6*360/1000);
    },
    getRainCatchmentArea(){
      // return rain catchment area in sqft
      // assume the gross area is evenly divided by floors
      return this.items[1].items[0].value/this.items[1].items[1].value/1000;
    },
    getCisternSize(){
      // return rain catchment area in sqft
      // assume the gross area is evenly divided by floors
      return this.items[1].items[0].value/this.items[1].items[1].value/1000;
    }
  },
  beforeMount() {
    // this.drawer = this.$vuetify.breakpoint.lgAndUp
  },
  mounted: function(){
    // start by setting building to educational so that the
    this.inputChange(this.items[1].items[2])
  }
}
</script>
